// extracted by mini-css-extract-plugin
export default {"row":"Cognition_row__dLxf4","col1":"Cognition_col1__YOF19","col2":"Cognition_col2__ngcEZ","col3":"Cognition_col3__OoDl8","col4":"Cognition_col4__ihzZL"};